import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getUsersOrders, confyrm } from '../../http/orderAPI'



export const fetchOrders = createAsyncThunk(
    'history/fetchOrders',
    async function (_, { rejectWithValue, dispatch }) {
        dispatch(clearErrors())

        try {
            const data = await getUsersOrders()
            return data

        } catch (error) {
            // если есть ответ от сервера
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data); 
            }
            return rejectWithValue({ message: error.message || 'Unknown error' });
        }
    }
)

export const confyrmOrder = createAsyncThunk(
    'history/confyrmOrder',
    async function ({id}, { rejectWithValue, dispatch }) {
        dispatch(clearErrors())

        try {
            const data = await confyrm(id)
            return data

        } catch (error) {
            // если есть ответ от сервера
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data); 
            }
            return rejectWithValue({ message: error.message || 'Unknown error' });
        }
    }
)

const historySlice = createSlice({
    name: 'history',
    initialState: {
        isLoading: false,
        error: null,
        data: null
    },
    reducers: {
        clearErrors(state) {
            state.error = null
            state.data = null
        }
    },
    extraReducers: builder => {
        builder

            .addCase(fetchOrders.pending, (state) => {
                state.isLoading = true
            })
            .addCase(fetchOrders.rejected, (state, action) => {
                state.isLoading = false;
            
                // Если rejectWithValue с сервером, данные будут в action.payload
                if (action.payload?.message) {
                    state.error = action.payload.message;
                } else {
                    // fallback на стандартное сообщение
                    state.error = action.error?.message || "Возникла ошибка!";
                }
            })
            .addCase(fetchOrders.fulfilled, (state, action) => {
                state.isLoading = false
                state.data = action.payload.data
            })

            .addCase(confyrmOrder.fulfilled, (state, action) => {
                state.isLoading = false
                state.data = action.payload.data
            })

    }
});

export const {
    clearErrors
} = historySlice.actions;

export default historySlice.reducer